import React, { Component } from 'react';
import {Auth} from 'aws-amplify';

class FirstTimePasswordChange extends Component {

  state = {
    inputNewPassword1: '',
    inputNewPassword2: '',
    inputEmail: '',
    inputEmail2: ''
  }

  componentDidMount() {

  }

  render() {

    const {updateInput, handleUpdatePassword} = this;
    const {inputNewPassword1, inputNewPassword2, inputEmail, inputEmail2} = this.state;

    return (
      <div className="FirstTimePasswordChangePage">
        <h1>First Time Sign In</h1>
        <label htmlFor="inputNewPassword1">New Password</label>
        <input id="inputNewPassword1" value={inputNewPassword1} onChange={updateInput} type="password"></input>
        <label htmlFor="inputNewPassword2">Confirm New Password</label>
        <input id="inputNewPassword2" value={inputNewPassword2} onChange={updateInput} type="password"></input>
        <label htmlFor="inputEmail">Email Address</label>
        <input id="inputEmail" value={inputEmail} onChange={updateInput}></input>
        <label htmlFor="inputEmail2">Confirm Email Address</label>
        <input id="inputEmail2" value={inputEmail2} onChange={updateInput}></input>
        <button onClick={handleUpdatePassword}>Update Password</button>
      </div>
    );
  }

  updateInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  handleUpdatePassword = () => {

    const {pushToLog, firstTimeUser, updateUserState} = this.props;
    const {inputNewPassword1, inputNewPassword2, inputEmail, inputEmail2} = this.state;

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const specialCharRegex = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;

    if (inputNewPassword1 !== inputNewPassword2) pushToLog('Passwords must match.');
    else if (inputNewPassword1 === '') pushToLog('Password cannot be blank.');
    else if (inputNewPassword1.length < 8) pushToLog('Password must be at least 8 characters long.');
    else if (!/[0-9]/.test(inputNewPassword1)) pushToLog('Password must contain at least one number.');
    else if (!/[a-z]/.test(inputNewPassword1)) pushToLog('Password must contain at least one lower case letter.');
    else if (!/[A-Z]/.test(inputNewPassword1)) pushToLog('Password must contain at least one upper case letter.');
    else if (!specialCharRegex.test(inputNewPassword1)) pushToLog('Password must contain at least one special character.');
    else if (inputEmail !== inputEmail2) pushToLog('Email addresses must match.');
    else if (inputEmail === '') pushToLog('Email cannot be blank.');
    else if (!emailRegex.test(inputEmail)) pushToLog('Please enter a valid email.');
    else {
      Auth.completeNewPassword(firstTimeUser, inputNewPassword1, {email: inputEmail})
      .then(res => {

        pushToLog('Password successfully changed.');
        if (res.challengeName === 'MFA_SETUP') pushToLog('Multi factor authentication must be setup.');
        this.setState({inputNewPassword1: '', inputNewPassword2: '', inputEmail: '', inputEmail2: ''});
        updateUserState({firstTimeUser: res, challengeName: res.challengeName});

      })
      .catch(err => {

        if (err.message === 'Invalid session for the user, session is expired. ---') {
          pushToLog('Your session expired. Please log in again.');
          updateUserState({firstTimeUser: {}, challengeName: 'LOGGED_OUT'});
        } else {
          console.log(err);
        }

      });
    }

  }

}

export default FirstTimePasswordChange;


// WEBPACK FOOTER //
// ./src/components/content/user/userComponents/firstTimePasswordChange.js